export const socials = {
    facebook: "https://www.facebook.com/profile.php?id=61563069701844",
    instagram: "https://www.instagram.com/thelanguagejeanie/",
    tiktok: "https://www.tiktok.com/@thelanguagejeanie",
}